(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    // udržuj správne hodnoty
    window.addEventListener('load', () => {
      this.setHeaderHeight();
      requestAnimationFrame(() => this.setHeaderHeight()); // po jednom frame ešte raz
    });
    window.addEventListener('resize', this.setHeaderHeight.bind(this));
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  // ===== jediná zásadná zmena je tu =====
  setHeaderHeight() {
    if (!this.header) return;
    const rect = this.header.getBoundingClientRect();
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    // Ak sme úplne hore, použi presnú výšku headera (žiadne desatinné „vlasy“).
    const bottomPx = scrollY <= 1 ? this.header.offsetHeight : Math.max(0, rect.bottom);

    document.documentElement.style.setProperty('--header-height', `${Math.round(rect.height)}px`);
    document.documentElement.style.setProperty('--header-bottom-position', `${Math.round(bottomPx)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }
  // ======================================

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // priebežne aktualizuj „spodok“ headera
    const rect = this.header.getBoundingClientRect();
    const scrollY = window.scrollY || 0;
    const bottomPx = scrollY <= 1 ? this.header.offsetHeight : Math.max(0, rect.bottom);
    document.documentElement.style.setProperty('--header-bottom-position', `${Math.round(bottomPx)}px`);

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() { /* nezmenené */ }
  reveal() { /* nezmenené */ }
  reset() { /* nezmenené */ }
  closeMenuDisclosure() { /* nezmenené */ }
  closeSearchModal() { /* nezmenené */ }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
